
//API Error type
export const  TOKEN_ERROR  = "JsonWebTokenError";       


export function handleSystemErrors(error){

    // console.log('error',error);
    if(error.name){
        switch(error.name){
            case TOKEN_ERROR:{
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                localStorage.removeItem("company");
                localStorage.removeItem("appControlObj");
                window.location.href = '/';
                break;
            }
            default:
                alert('Error fetching data from DB!');
                break;
        }
    }
    return

} 